/**
 * Collection Grid: Content Filter & Globo Sync
 * Manages the visual state of custom filter buttons (.js-content-filter)
 * and keeps them in sync with Globo's native filter checkboxes.
 *
 * Extracted from main-collection-product-grid.liquid (pure JS, no Liquid)
 */
(function () {
  const ACTIVE = 'filters-applied';
  const elements = document.querySelectorAll('.js-content-filter');
  if (!elements.length) return;
  const isWomensBottoms = !!document.querySelector('.womens-bottom-container');
  const getGloboBtn = (value) => document.querySelector(`button[role="checkbox"][data-fvalue="${value}"]`);
  const getGloboBtns = (valuesStr) => {
    const values = valuesStr
      .split(',')
      .map((v) => v.trim())
      .filter((v) => v);
    return values.map((value) => getGloboBtn(value)).filter(Boolean);
  };
  const setActive = (el, active) => {
    const target = el.type === 'radio' ? el.closest('.radio-button') : el;
    target.setAttribute('data-state', active ? ACTIVE : '');
  };
  const clearVisuals = () => elements.forEach((el) => setActive(el, false));
  const syncVisuals = () => {
    elements.forEach((el) => {
      const isRadio = el.type === 'radio';
      const valuesStr = el.dataset.filterValues;
      if (isRadio) {
        const gBtns = getGloboBtns(valuesStr);
        const isViewAll = el.value === 'viewAll';
        if (isViewAll) {
          if (gBtns.length === 2 && gBtns.every((g) => g.getAttribute('aria-checked') !== 'true')) {
            setActive(el, true);
          } else {
            setActive(el, false);
          }
        } else {
          if (gBtns.length && gBtns.every((g) => g.getAttribute('aria-checked') === 'true')) {
            setActive(el, true);
          } else {
            setActive(el, false);
          }
        }
      } else {
        const gBtn = getGloboBtn(valuesStr);
        setActive(el, gBtn?.getAttribute('aria-checked') === 'true');
      }
    });
  };
  const clearAllFilters = () => {
    document.querySelectorAll('button[role="checkbox"][aria-checked="true"]').forEach((btn) => btn.click());
  };
  elements.forEach((el) => {
    if (el.type === 'radio') {
      el.addEventListener('change', function (e) {
        if (!this.checked) return;
        const valuesStr = this.dataset.filterValues;
        const gBtns = getGloboBtns(valuesStr);
        if (gBtns.length === 0) return;
        const isViewAll = this.value === 'viewAll';
        clearVisuals();
        setActive(this, true);
        clearAllFilters();
        if (!isViewAll) {
          setTimeout(() => gBtns.forEach((g) => g.click()), 300);
        }
      });
    } else {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        const valuesStr = this.dataset.filterValues;
        const gBtn = getGloboBtn(valuesStr);
        if (!gBtn) return;
        const wasActive = gBtn.getAttribute('aria-checked') === 'true';
        setActive(this, !wasActive);
        gBtn.click();
      });
    }
  });
  document.querySelectorAll('.js-radio-button label').forEach((label) => {
    label.addEventListener('click', function (e) {
      const radio = document.getElementById(this.htmlFor);
      if (radio && !radio.checked) {
        e.preventDefault();
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
  const setupSync = () => {
    syncVisuals();
    document.addEventListener('globo.filter.updated', syncVisuals);
    const clearAllBtn = document.querySelector('.clear-link-button');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', () => {
        setTimeout(() => {
          clearVisuals();
          const viewAllDesktop = document.getElementById('jeans-viewAll');
          const viewAllMobile = document.getElementById('jeans-viewAll-mobile');
          if (viewAllDesktop) {
            viewAllDesktop.checked = true;
            setActive(viewAllDesktop, true);
          }
          if (viewAllMobile) {
            viewAllMobile.checked = true;
            setActive(viewAllMobile, true);
          }
        }, 250);
      });
    }
  };
  const wait = setInterval(() => {
    if (getGloboBtn('Jeans') || getGloboBtn('Trousers') || getGloboBtns('321801617580,321801650348').length > 0) {
      clearInterval(wait);
      setupSync();
    }
  }, 250);
  setTimeout(() => clearInterval(wait), 10000);
})();
